import React from 'react';
import { Empty, Timeline, Row, Col, Tooltip, Avatar } from 'antd';
import { DesktopOutlined, FileImageOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Item } = Timeline;

const colStyle = {
  fontFamily: 'roboto',
  fontSize: '105%',
  fontWeight: 700,
  color: '#636363',
  wordWrap: 'break-word',
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
  whiteSpace: 'normal',
  maxWidth: '100%',
  display: 'block',
};

const SignupImpressionsView = ({ impressionsData }) => {
  if (!impressionsData?.impressions || impressionsData.impressions.length === 0) {
    return <Empty description="No impressions" />;
  }

  const impressions = [...impressionsData.impressions].sort((a, b) => {
    return new Date(b.impressionTime) - new Date(a.impressionTime);
  });

  const makeTimeLine = impressions.map((impression, i) => (
    <Item key={i}>
      <Row gutter={[8, 8]} style={{ width: '100%' }}>
        <Col xs={24} sm={12} md={6}>
          <div style={colStyle}>
            {`Impression served - ${moment(impression.impressionTime).format('MM/DD/YY HH:mm:ss.SSSZ')}`}
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div style={colStyle}>
            <Tooltip title={impression.media || ''}>{impression.media || 'N/A'}</Tooltip>
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div style={colStyle}>
            <Avatar
              size={50}
              icon={<FileImageOutlined />}
              alt={impression.impressionPublisherMedia}
              src={impression.impressionPublisherMedia}
              style={{ marginBottom: '8px' }}
            />
            <br />
            <Tooltip title={impression.impressionPublisher || ''}>
              {`Served on - ${impression.impressionPublisher || 'N/A'}`}
            </Tooltip>
            <br />
            {impression.impressionPublisherUrl &&
              impression.impressionPublisherUrl !== 'about:blank' && (
                <a
                  href={impression.impressionPublisherUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Visit Application
                </a>
              )}
            <br />
          </div>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <div style={colStyle}>
            {impression.impressionPublisherPlatform || 'N/A'} <DesktopOutlined />
            <br />
            {impression.impressionPublisher && (
              <Tooltip title={impression.impressionPublisher || ''}>
                {`Published by - ${impression.impressionPublisher}`}
              </Tooltip>
            )}
          </div>
        </Col>
      </Row>
    </Item>
  ));

  return (
    <div style={{ marginRight: 100 }}>
      <Timeline mode={'left'} reverse={true}>
        {makeTimeLine}
      </Timeline>
    </div>
  );
};

export default SignupImpressionsView;
